import { createFileRoute } from '@tanstack/react-router';
import { PersonDevicesRoute } from './-route-wrappers';

/** The person profile's Devices tab at its own URL (FPS-2712). */
function PersonDevicesIndexRoute() {
  return <PersonDevicesRoute />;
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/people/$personId/devices/')({
  component: PersonDevicesIndexRoute,
});
